function handleNumberFormat(number: number): string {
  if (number < 10) {
    return `0${number}`.slice(-2);
  }

  return Math.abs(number) > 999
    ? `${Math.sign(number) * Number((Math.abs(number) / 1000).toFixed(1))}K`
    : String(Math.sign(number) * Math.abs(number));
}

export default handleNumberFormat;
